/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Popup_BlockedInputs */



/**
* | output |
* | --- |
* | "Allow pop-ups for this site to open the artifact in its own window." |
*
* @param {Artifact_Popup_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_popup_blocked = /** @type {((inputs?: Artifact_Popup_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Popup_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaube Pop-ups für diese Seite, um das Artefakt in einem eigenen Fenster zu öffnen.")
	return /** @type {LocalizedString} */ ("Allow pop-ups for this site to open the artifact in its own window.")
});